export const DurationOptions = {
  "1D": {
    hAxisFormat: "HH:MM",
    timeRange: "day",
    durationText:"today",
  },
  "1W": {
    hAxisFormat: "dd MMM",
    timeRange: "week",
    durationText:"past week",
  },
  "1M": {
    hAxisFormat: "dd MMM",
    timeRange: "month",
    durationText:"past month",
  },
  "3M": {
    hAxisFormat: "dd-MM-YYYY",
    timeRange: "threeMonths",
    durationText:"past 3 months",
  },
};
